<template>
    <Card :title="$t('crmAnalyticsPage.ordersSumCardTitle')">
        <div class="card-body">
            <StackedColumnChartComponent
                :data="chartData"
                :timeLineRange="timeLineRange"
                :color="color"
                measurement="грн."
            />
        </div>
    </Card>
</template>
<script>
import Card from '../../../../../components/new/CardComponent.vue'
import StackedColumnChartComponent from '../../../../../components/chart/StackedColumnChartComponent.vue';

export default {
    name: "OrdersSum",
    components: {
        Card, StackedColumnChartComponent
    },
    props: {
        timeLineRange: {
            type: Array,
            required: false,
            default: () => []
        },
        chartData: {
            type: Object,
            required: false,
            default: () => ({})
        },
        color: {
            type: Array,
            required: false,
            default: () => []
        }
    }
}
</script>
